import { Validators, AbstractControl } from '@angular/forms';
import { CustomValidators } from '@narik/custom-validators';
import { BaseVariableControl } from './_base-control';



export class SliderControl extends BaseVariableControl {

    createReactiveControl(setValueChangedEvent: boolean = true) {

        this.addFormControl();

        this.setValidators(this.form.controls[this.variable.name]);

        if (setValueChangedEvent) {
            this.setOnChangeEvent(this.form.controls[this.variable.name]);
            this.variable.value = this.getVariableValue();
        }
    }

    setValidators(formControl: AbstractControl) {

            const validators = this.variable.displayMetadata.templateData.validators?.map(element => {

            let type = <string> element.typeId;
            if (type.includes("RequiredAttribute"))
            {
                return Validators.required;
            }
        });

        formControl.setValidators(Validators.compose([CustomValidators.min(0)]));
        formControl.addValidators(validators);
    }
}
